import * as PlussCore from '@plusscommunities/pluss-core-web';
// import * as PlussCore from '../pluss-extension-web/pluss-core/src';

export { PlussCore };
